import React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { useQuery } from '../../hooks/useQuery';
import { getSafeRedirectPath } from '../../utils/redirect';
import { Redirect } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingScreen from '../LoadingScreen';

export interface ProtectedRouteProps extends RouteProps{
    redirectPath?: string;
    // exact?: boolean | undefined;
    
}

const ProtectedAuthRoute: React.FC<ProtectedRouteProps> = ({ redirectPath = '/', ...props })=>{

    // Signed-in users are sent away from auth pages (sign in, sign up, ...),
    // to the page that sent them to sign in when there is one.
    const { status } = useAuth();
    const query = useQuery();
    if (status === 'loading') {
        return <LoadingScreen />
    }
    if (status === 'authenticated') {
        return <Redirect to={getSafeRedirectPath(query.get('redirect')) ?? redirectPath} />
    }

    return(
        <Route {...props} />
    )
}

export default ProtectedAuthRoute;
